import {useState} from 'react';
import {Header} from '../../shared/components/Header';
import {Text} from '@gs-ux-uitoolkit-react/text';
import {Button} from '@gs-ux-uitoolkit-react/button';
import {Footer} from '../../shared/components/Footer';
import {FormControl} from '@gs-ux-uitoolkit-react/form';
import {FormInput} from '../../shared/components/FormInput';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import {toastService} from '@gs-ux-uitoolkit-react/toast';
import { useNavigate } from 'react-router-dom';

export function AdviseeMfaVerification() {
    const { token } = useParams<{ token: string }>(); // Extract token from the URL
    const mfaType = localStorage.getItem('mfaType');
    const [code, setCode] = useState('');
    const [errorMessage, setErrorMessage] = useState<string | null>(null); // State for error messages
    const navigate = useNavigate(); // Initialize the navigate function

    const handleVerify = () => {
        const url = `/api/v2/password-invitation/${token}/mfa-verification-attempts?code=${code}`;
        axios
            .post(url) 
            .then(async () => {
                navigate(`/create-password/${token}/set-password`); // Redirect to the set security q/a and password page
            }).catch((error) => {
            toastService.show({
                status: 'error',
                message: error?.response?.data?.displayMessage,
                placement: 'top',
                dismissible: true,
                className: 'top-20',
                autoDismiss: 3_500
            });
            console.error("Error:", error);
        });
    };

    const resendTheCode = () => {
        const url = `/api/v2/password-invitation/${token}/mfa-attempts?mfaType=${mfaType}`; // Add mfaType as a query parametertoken
        axios
            .post(url, { token }) // Send only token in the body if needed
            .then(() => {
                toastService.show({
                    status: 'success',
                    message: `Code has been resent!`,
                    placement: 'top',
                    dismissible: true,
                    className: 'top-20',
                    autoDismiss: 3_500
                });
            })
            .catch((error) => {
                console.error("Error:", error.data.displayMessage);
            });
    };

    return (
        <>
            <Header/>
            <div
                className="justify-between flex-1 flex flex-col min-[700px]:flex-row items-center px-16 py-16 xl:gap-72 lg:gap-24 md:gap-12 sm:gap-6">
                <div className="self-stretch px-6 inline-flex justify-center items-center gap-2.5">
                    <Text typography="textSubtitle03Medium">For security purposes, please confirm your phone number to receive a one-time security code.</Text>
                </div>
            </div>
            <div className="flex flex-col px-16 ">
                <div className="self-stretch px-6 py-6">
                    <div className="flex flex-col gap-2 pb-4">
                        <Text typography="textBody02Regular">Verify the code</Text>
                        <Text typography="textBody04Regular">Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.</Text>
                    </div>
                    <FormControl>
                        <FormInput
                            isRequired
                            className="max-w-xs"
                            placeholder='Enter the code you received'
                            name={`code`}
                            error={errorMessage || undefined}
                            setValue={(newVal) => setCode(newVal)}
                            value={code}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="col-span-12 mt-4 px-20 py-4 bg-gray-10 flex flex-row gap-4 ">
                <Button
                    className="bg-gray-20 rounded"
                    size="lg"
                    onClick={resendTheCode} 
                    emphasis="subtle" 
                    appearance="neutral"
                >
                    Resend the code
                </Button>
                <Button
                    className="bg-blue-60 rounded"
                    size="lg"
                    onClick={handleVerify} 
                    appearance="neutral"
                >
                    Verify
                </Button>
            </div>
            <Footer/>
        </>
    );
}
